// ── 녹음 무결성 기준 (PORTAL-12592 · 12587) ────────────────────────────
// 빈/손상 녹음이 검증 없이 올라가 '저장 성공' 으로 남는 걸 막는다.
// 녹음 직후 업로드 전뿐 아니라, 비정상 종료 녹음을 되살릴 때와 백업을 다시 올릴 때도
// 같은 기준으로 가른다 — 어느 경로로 들어온 파일이든 같은 판정을 받게.
export const MIN_RECORDING_BYTES = 1024; // 컨테이너 헤더만 있는 사실상 빈 파일 차단
export const MIN_RECORDING_DURATION_SEC = 1; // 길이 확정 실패(0) 및 1초 미만 차단

// 업로드를 막아야 하는 사유 — 정상이면 null.
// duration 0 은 getAudioDuration 이 길이를 확정 못 한 경우(디코딩 실패·타임아웃)도
// 포함하므로, 별도 손상 검사 없이 길이 검사만으로 함께 걸러진다.
export const getInvalidRecordingReason = (
  blob: Blob,
  duration: number,
): string | null => {
  if (blob.size < MIN_RECORDING_BYTES) return `size ${blob.size}B`;
  if (duration < MIN_RECORDING_DURATION_SEC) return `duration ${duration}s`;
  return null;
};

/** 'HH:MM:SS'(formatToHHMMSS 결과) → 초. 읽을 수 없으면 0 — 길이 미확정으로 본다 */
export const parseHHMMSS = (text: string): number => {
  const parts = text.split(':').map(Number);
  if (parts.length === 0 || parts.some((n) => !Number.isFinite(n))) return 0;
  return parts.reduce((acc, n) => acc * 60 + n, 0);
};
